export enum OrderStatus {
    New = 'New',
    Accepted = 'Accepted',
    Denied = 'Denied'
}
